import { ChatFeedContainer, QuickChatFeedContainer } from './styles';

export {
  QuickChatFeedContainer,
};

export default ChatFeedContainer;
